import { Component, OnInit } from '@angular/core';
import { ThemeService } from './services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'ccs-mobilization-app';

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    // Theme service automatically initializes saved or preferred theme
  }
}

